export default {"src":"/_next/static/media/avatar.fafc1340.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};